import React from "react";
import { Link } from "react-router-dom";
import "./Hero.css";
import tyreImage from "../assets/EWT.webp";
import tyrefitting from "../assets/DEA.webp";
import brands2 from "../assets/VDR.webp";
import bgVideo from "../assets/Bg-Vid-21.webm";

function Hero() {
  return (
    <section className="hero">
      <div className="video-wrap">
        <video
          className="slider-video"
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        >
          <source src={bgVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <div className="hero-text">
          <div className="pre-title-wrapper">
            <div className="pre-title-accent"></div>
            <h4>CAR FORENSICS LTD</h4>
          </div>

          <h1>Professional Mobile Garage & Car Forensics Services</h1>
          <p>
            We’re a family run team with over 15 years of experience
            <br />
            in car diagnostics and mobile garage services, offering fast, accurate fault finding and trusted repairs.
          </p>

          <div className="hero-buttons">
            <a href="tel:+447501911970" className="call-btn">
              <span className="btn-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </span>
              Call Us Now: +447501911970
            </a>

            <a href="tel:+447501911970" className="emergency-btn">
              <span className="btn-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12 6 12 12 16 14"></polyline>
                </svg>
              </span>
              Emergency Out Of Hours Call Out
            </a>
          </div>
        </div>
      </div>

      <div className="services-cards-container">
        <div className="services-cards">
          <div className="services-card">
            <div className="cards-image">
              <img src={brands2} alt="Vehicle diagnostics and repair service" loading="lazy" />
              <div className="image-overlay"></div>
            </div>
            <div className="cards-content">
              <div className="cards-number">01</div>
              <h3>Vehicle Diagnostics & Repair</h3>
              <p>Professional garage services with advanced diagnostic technology</p>
              <Link to="/diagnostic" className="card-cta">
                <span>Learn More</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
          </div>

          <div className="services-card">
            <div className="cards-image">
              <img src={tyrefitting} alt="ECU services and digital evidence analysis" loading="lazy" />
              <div className="image-overlay"></div>
            </div>
            <div className="cards-content">
              <div className="cards-number">02</div>
              <h3>Digital Evidence Analysis</h3>
              <p>Advanced ECU data extraction and vehicle computer forensics</p>
              <Link to="/ecu-remapping" className="card-cta">
                <span>View Services</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
          </div>

          <div className="services-card">
            <div className="cards-image">
              <img src={tyreImage} alt="Mobile garage service across Kent" loading="lazy" />
              <div className="image-overlay"></div>
            </div>
            <div className="cards-content">
              <div className="cards-number">03</div>
              <h3>Mobile Garage Service</h3>
              <p>We come to you - professional mobile garage services at your location</p>
              <Link to="/contact" className="card-cta">
                <span>Book Now</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Hero;
